"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddGranteeContent = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var sdk_model_1 = require("@gooddata/sdk-model");
var GranteeList_1 = require("./GranteeList");
var AddGranteeSelect_1 = require("./AddGranteeSelect");
/**
 * @internal
 */
exports.AddGranteeContent = function (props) {
    var appliedGrantees = props.appliedGrantees, currentUserRef = props.currentUserRef, addedGrantees = props.addedGrantees, onDelete = props.onDelete, onAddUserOrGroups = props.onAddUserOrGroups;
    var onSelectGrantee = react_1.useCallback(function (grantee) {
        if (!appliedGrantees.some(function (g) { return sdk_model_1.areObjRefsEqual(g.id, grantee.id); })) {
            onAddUserOrGroups(grantee);
        }
    }, [appliedGrantees, onAddUserOrGroups]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(AddGranteeSelect_1.AddGranteeSelect, { currentUserRef: currentUserRef, appliedGrantees: appliedGrantees, onSelectGrantee: onSelectGrantee }),
        react_1.default.createElement(GranteeList_1.GranteeList, { grantees: addedGrantees, mode: "AddGrantee", onDelete: onDelete })));
};
//# sourceMappingURL=AddGranteeContent.js.map